export var valuesMessageType = ["None", "Info", "Warning", "Error"];
/*

*/ 
//# sourceMappingURL=MessageType.js.map